var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormHelperText, Grid, } from "@mui/material";
import { useEffect, useState } from "react";
import { RegistrationCompletionSchema, } from "./RegistrationSchema";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { TextFieldPM } from "../SharedFormParts/TextField";
import { AutocompleteSelectPM } from "../SharedFormParts/AutocompleteSelect";
import countryList from "../static/assets/countryList.json";
import { executeWithTokenRefresh } from "./executeWithTokenRefresh";
export function CompleteUserInfoDialog() {
    var _a, _b, _c;
    const [open, setOpen] = useState(false);
    const [resolve, setResolve] = useState(() => { });
    const [wait, setWait] = useState(false);
    const [error, setError] = useState("");
    const formMethods = useForm({
        resolver: yupResolver(RegistrationCompletionSchema),
        defaultValues: { affiliation: "", country: "", city: "" },
    });
    const { handleSubmit, register, formState: { errors }, } = formMethods;
    const onSubmit = (regCompletionData) => __awaiter(this, void 0, void 0, function* () {
        console.log(0);
        setWait(true);
        setError("");
        const response = yield executeWithTokenRefresh(() => fetch(`${window.location.origin}/v2/users/update`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(regCompletionData),
        }));
        if (response.success) {
            resolve(regCompletionData);
            setOpen(false);
        }
        else {
            setError(response.error);
        }
        setWait(false);
    });
    //   const closeAndReturnData = async () => {
    //     if (userData) {
    //       resolve(userData);
    //       setOpen(false);
    //       setUserData(undefined);
    //     }
    //   };
    useEffect(() => {
        const _cb = (e) => {
            const { resolve } = e.detail;
            setResolve(() => resolve);
            setOpen(true);
        };
        window.addEventListener("PM-CompleteUserInfo", _cb);
        return () => {
            window.removeEventListener("PM-CompleteUserInfo", _cb);
        };
    }, []);
    return (_jsxs(Dialog, Object.assign({ open: open, 
        //   onClose={(event, reason) => {
        //     if (reason === "backdropClick") closeAndReturnUndefined();
        //   }}
        fullWidth: true, sx: { "& .MuiPaper-root": { pt: 1 } } }, { children: [_jsx(DialogTitle, Object.assign({ textAlign: "center", variant: "h5" }, { children: "Complete your user information" })), _jsx("form", Object.assign({ onSubmit: handleSubmit(onSubmit) }, { children: _jsx(FormProvider, Object.assign({}, formMethods, { children: _jsxs(DialogContent, { children: [_jsxs(Grid, Object.assign({ container: true, direction: "column", spacing: 2 }, { children: [_jsx(Grid, Object.assign({ item: true, xs: true }, { children: _jsx(DialogContentText, Object.assign({ textAlign: "center", color: "primary" }, { children: "Welcome! We need a bit more information to complete your account details. Please fill in the following fields to continue:" })) })), _jsx(Grid, Object.assign({ item: true, xs: true }, { children: _jsx(TextFieldPM, { formKey: "affiliation", label: "Affiliation", error: (_a = errors["affiliation"]) === null || _a === void 0 ? void 0 : _a.message }) })), _jsx(Grid, Object.assign({ item: true, xs: true }, { children: _jsx(AutocompleteSelectPM, { hookFormRegisterFunc: register, formKey: "country", label: "Country", error: (_b = errors["country"]) === null || _b === void 0 ? void 0 : _b.message, options: countryList }) })), _jsx(Grid, Object.assign({ item: true, xs: true }, { children: _jsx(TextFieldPM, { formKey: "city", label: "City", error: (_c = errors["city"]) === null || _c === void 0 ? void 0 : _c.message }) }))] })), error ? (_jsx(Grid, Object.assign({ item: true, xs: true }, { children: _jsx(DialogContentText, Object.assign({ sx: { pt: 1 }, component: FormHelperText, textAlign: "center", error: true }, { children: error })) }))) : null, _jsx(Grid, Object.assign({ item: true, xs: true }, { children: _jsx(DialogActions, Object.assign({ sx: { justifyContent: "center" } }, { children: _jsx(Button, Object.assign({ type: "submit", variant: "contained", disabled: wait }, { children: wait ? _jsx(CircularProgress, { size: 21 }) : "confirm" })) })) }))] }) })) }))] })));
}
export function dispatchCompleteUserInfoEvent() {
    return new Promise((resolve, reject) => {
        window.dispatchEvent(new CustomEvent("PM-CompleteUserInfo", {
            detail: { resolve },
        }));
    });
}
